import { FreightPickupWindowRowSchema } from "@redotech/redo-model/freight/freight-pickup-window";
import * as z from "zod";

export const getFreightPickupWindows = {
  name: "getFreightPickupWindows" as const,
  input: z.object({}),
  output: z.object({ pickupWindows: z.array(FreightPickupWindowRowSchema) }),
};
